// BTMultilineInputBox.tsx
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

interface BTMultilineInputBoxProps {
    borderColor?: string;
    value?: string;
    disabled?: boolean;
    width?: string;
    style?: React.CSSProperties;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const BTMultilineInputBox: React.FC<BTMultilineInputBoxProps> = ({
    borderColor,
    value = '',
    disabled,
    width = '100%',
    onChange,
    style,
}) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto'; // reset height
            textarea.style.height = `${textarea.scrollHeight}px`; // adjust to content
        }
    }, [value]);

    return (
        <StyledTextarea
            ref={textareaRef}
            value={value}
            onChange={onChange}
            $borderColor={borderColor}
            $width={width}         // 래퍼 안에서만 100%
            disabled={disabled}
            readOnly={disabled}   // readOnly가 더 적절한 경우도 있음
            style={style}
        />
    );
};

export default BTMultilineInputBox;

const StyledTextarea = styled.textarea<{
    $borderColor?: string;
    $width?: string;
}>`
    box-sizing: border-box;
    max-width: 100%;
    display: block;
    min-width: 0;
    border: 1px solid ${({ $borderColor }) => $borderColor || '#adb5bd'};
    border-radius: 4px;
    padding: 10px;
    width: ${({ $width }) => $width || '100%'};
    min-height: 250px;
    height: auto;
    font-size: 16px;
    color: #232d42;
    background-color: transparent;
    outline: none;
    resize: none;
    overflow: hidden; /* 중요: scroll bar 제거 */
    overflow-x: hidden; /* 가로 넘침 방지 */
    word-break: break-word; /* 예외적 긴 토큰 대응 */
`;